import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import {
  AgingTimeUnit,
  BarrelType,
  GrainDistillateType,
  WhiskyType,
} from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { WhiskyProperties } from '@app/api/marketplace/models';

@Component({
  selector: 'app-whisky-properties-subform',
  templateUrl: './whisky-properties-subform.component.html',
  styleUrls: ['./whisky-properties-subform.component.scss'],
})
export class WhiskyPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.WHISKY_PROPERTIES';

  types = WhiskyType;
  barrelTypes = BarrelType;
  agingTimeUnits = AgingTimeUnit;
  grainDistillateTypes = GrainDistillateType;

  Validators = Validators;

  static buildForm(
    fb: FormBuilder,
    data: WhiskyProperties | undefined,
    isSecondaryProductSheet: boolean
  ) {
    return fb.group({
      type: [data?.type, Validators.required],
      ...(!isSecondaryProductSheet && {
        barrelType: [data?.barrelType],
      }),
      agingTime: [data?.agingTime],
      agingTimeUnit: [
        data?.agingTimeUnit,
        data?.agingTime ? [Validators.required] : [],
      ],
      grainDistillateType: [data?.grainDistillateType, Validators.required],
    });
  }
}
